import { gray2, lightBlue, marketingMobileCuttoff, red } from '@css/constants'
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles'
import {css} from '@emotion/core'
import styled from '@emotion/styled'

export const ProductGridSectionContainer = styled('div')(css`
  padding-top: 100px;
  padding-bottom: 100px;
  margin: 0 auto;

  @media(max-width: ${marketingMobileCuttoff}) {
    padding-top: 80px;
    padding-bottom: 80px;
  }
`)

export const ProductGridSectionTitle = styled('h3')(css`
  ${fontSize(32)};
  ${FontNormal(600)};
  text-align: center;

  @media(max-width: ${marketingMobileCuttoff}) {
    ${fontSize(24)};
    border-left: 10px solid ${lightBlue};
    padding-left: 15px;
    margin-bottom: 20px;
    text-align: start;
  }
`)

export const ProductGridSectionSubtitle = styled('h4')(css`
  ${fontSize(20)};
  ${FontNormal(400)};
  margin-bottom: 30px;
  text-align: center;

  @media(max-width: ${marketingMobileCuttoff}) {
    ${fontSize(16)};
    margin-bottom: 20px;
    padding-left: 25px;
    text-align: start;
  }
`)

export const ProductList = styled('div')(css`
  padding-left: 20px;
  padding-right: 20px;
  width: 90%;
  max-width: 970px;
  margin: 0 auto;
`)

export const ProdutListItem = styled('div')(css`
  width: 25%;
  margin-bottom: 15px;
  display: inline-block;

  @media(max-width: ${marketingMobileCuttoff}) {
    width: 50%;
    margin-bottom: 25px;
  }
`)

export const ProdutListItemImageWrapper = styled('div')(css`
  text-align: center;
`)

export const ProdutListItemImage = styled('img')(css`
  max-width: 180px;
  max-height: 180px;
  margin-bottom: 5px;

  @media(max-width: ${marketingMobileCuttoff}) {
    max-width: 130px;
    max-height: 130px;
  }
`)

export const ProductListItemTitle = styled('h3')(css`
  ${fontSize(24)};
  ${FontNormal(600)};
  text-align: center;
  margin-bottom: 5px;

  @media(max-width: ${marketingMobileCuttoff}) {
    ${fontSize(17)};
    margin-bottom: 13px;
  }
`)

export const ProductListItemSubtitle = styled('h4')(css`
  ${fontSize(15)};
  ${FontNormal(400)};
  text-align: center;

  @media(max-width: ${marketingMobileCuttoff}) {
    ${fontSize(14)};
  }
`)

export const ProductListItemCaption = styled('h5')<{
  isEnding?: boolean;
}>(props => css`
  ${fontSize(14)};
  ${FontNormal(400)};
  font-style: italic;
  text-align: center;
  color: ${props.isEnding ? red : gray2};
  display: none;

  @media(max-width: ${marketingMobileCuttoff}) {
    ${fontSize(12)};
  }
`)

export const ProductExploreButton = styled('div')(css`
  ${fontSize(24)};
  ${FontNormal(600)};
  font-style: italic;
  margin-top: 25px;
  text-align: center;

  @media(max-width: ${marketingMobileCuttoff}) {
    ${fontSize(20)};
  }
`)